import { render, staticRenderFns } from "./realTimeMonitoringtwo.vue?vue&type=template&id=612f56d0&scoped=true"
import script from "./realTimeMonitoringtwo.vue?vue&type=script&lang=js"
export * from "./realTimeMonitoringtwo.vue?vue&type=script&lang=js"
import style0 from "./realTimeMonitoringtwo.vue?vue&type=style&index=0&id=612f56d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f56d0",
  null
  
)

export default component.exports